/** @jsx h */
import { h } from "hyperapp";
import bus from "../bus";
import classNames from "classnames";
import { playerEvents } from "../player/events";
import { WrappedSvg } from "../utilities/hyperapp";
import signOut from "../sign-out";

import leftArrowIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../button/left-arrow.svg";
import rightArrowIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../button/right-arrow.svg";
import playIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../player/play-icon.svg";
import pauseIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../player/pause-icon.svg";
import playerBarsIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../player-bars/bars.svg";

export default function view(state, actions) {
  const {
    isLive,
    isReady,
    title,
    subtitle,
    isPlaying,
    destroyed,
    isOpen,
    isNull,
    offscreen,
    wiggle,
    account
  } = state;
  const { onDestroy, onCreate } = actions;
  if (destroyed) {
    return null;
  }

  function play(e) {
    e.preventDefault();
    bus.emit(playerEvents.SET, {
      status: "playing"
    });
  }

  function pause(e) {
    e.preventDefault();
    bus.emit(playerEvents.SET, {
      status: "paused"
    });
  }

  function togglePlayer(e) {
    e.preventDefault();
    if (isOpen) {
      bus.emit(playerEvents.CLOSE);
    } else {
      bus.emit(playerEvents.OPEN);
    }
  }

  return (
    <div
      class="masthead__player-inner"
      oncreate={onCreate}
      ondestroy={onDestroy}
    >
      {account ? (
        <div class="masthead__account-controls">
          <a class="masthead__sign-in-link mr-small" href="/account">
            <span class="desktop-only">Your account</span>
            <span class="tablet-and-phone-only">Account</span>
          </a>
          <button
            class="masthead__sign-in-link mr-small"
            onclick={e => {
              e.preventDefault();
              signOut();
            }}
          >
            <span class="desktop-and-tablet-only" data-test="sign-out-link">Sign out</span>
          </button>
        </div>
      ) : (
        <a class="masthead__sign-in-link mr-small" href="/sign-in">
          Sign in
        </a>
      )}
      <div
        class={classNames("masthead__player-wrapper", {
          "masthead__player-wrapper--sticky": offscreen
        })}
      >
        <div
          class={classNames("player", "d-flex", "flex-items-v-center", {
            "player--is-loading": !isReady,
            "player--is-playing": isPlaying,
            "player--wiggle": wiggle
          })}
        >
          <button
            class="player__play-button-wrapper"
            onclick={isPlaying ? pause : play}
            ga-on="click,auxclick,contextmenu"
            ga-event-category="audio"
            ga-event-action={isPlaying ? "pause" : "play"}
            ga-event-label={title}
          >
            <div class="player__play-button d-flex flex-items-center">
              <span class="player__loading-icon" />
              <span class="player__play-icon">
                <WrappedSvg data={playIcon} />
              </span>
              <span class="player__pause-icon">
                <WrappedSvg data={pauseIcon} />
              </span>
            </div>
          </button>
          <button class="player__details" onclick={togglePlayer}>
            {isLive ? (
              <span class="player__on-air caps-heading">
                {isNull ? null : (
                  <span class="player-bars">
                    <WrappedSvg data={playerBarsIcon} />{" "}
                  </span>
                )}
                On Air
                {isNull ? "/On Demand" : null}
              </span>
            ) : null}
            <span class="player__title">{title}</span>
            <span class="player__subtitle">{subtitle}</span>
            <div
              class={classNames(
                "player__toggle",
                "desktop-and-tablet-only",
                "d-flex",
                "flex-items-center",
                {
                  "player__toggle--is-playing": isPlaying
                }
              )}
            >
              {isOpen ? (
                <span key="left">
                  <WrappedSvg data={leftArrowIcon} />
                </span>
              ) : (
                <span key="right">
                  <WrappedSvg data={rightArrowIcon} />
                </span>
              )}
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
